import { useStyles } from '@webapps/styles';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';

import TextFieldPx from '../components/TextFieldPx';
import { css } from '@emotion/css';

const FormikTextField = ({
  children,
  formik: { errors, handleChange, touched, values },
  name,
  onChange,
  completed,
  borderRadius,
  min,
  max, // Ajouter min et max ici
  ...props
}) => {
  const { classes } = useStyles(styles);

  const handleFieldChange = (event) => {
    // Limiter la valeur si min et max sont définis
    if (min !== undefined || max !== undefined) {
      const value = parseFloat(event.target.value);

      if ((min !== undefined && value < min) || (max !== undefined && value > max)) {
        return; // Annuler les changements si hors des limites
      }
    }
    handleChange(event);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <TextFieldPx
      error={
        !!resolvePath(touched, name, '') && !!resolvePath(errors, name, '')
      }
      helperText={
        resolvePath(touched, name, '') && resolvePath(errors, name, '')
      }
      completed={completed}
      id={name}
      name={name}
      onChange={handleFieldChange}
      value={resolvePath(values, name, '')}
      disableUnderline="true"
      borderRadius={borderRadius}
      InputProps={{
        classes: {
          root: css({ disableUnderline: true, borderRadius: `${borderRadius}px !important` }),
        },
        inputProps: {
          min: min, // Appliquer min si défini
          max: max, // Appliquer max si défini
        },
      }}
      className={css({
        '.MuiInputBase-root': {
          borderRadius: `${borderRadius}px !important`,
        },
      })}
      {...props}
    >
      {children}
    </TextFieldPx>
  );
};

const styles = () => ({});

FormikTextField.propTypes = {
  field: PropTypes.elementType,
  name: PropTypes.string,
  formik: PropTypes.object,
  children: PropTypes.node,
  onChange: PropTypes.func,
  min: PropTypes.number, // Valider que min est un nombre
  max: PropTypes.number, // Valider que max est un nombre
};

export default FormikTextField;
